export const validateCellPhone = (value: string) => {
  const onlyDigits = String(value).replace(/\D/g, '')
  return /\d{11}/.test(onlyDigits)
}
